var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart"},[_c('NavBar',{staticClass:"nav-bar"},[_c('div',{attrs:{"slot":"center"},slot:"center"},[_vm._v("购物车("+_vm._s(_vm.length)+")")])]),(this.cartlistisexit)?_c('CartList'):_vm._e(),_c('CartBottomBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }